export default "__VITE_ASSET__ff5a15b4__"